export default "__VITE_ASSET__2a68e229__"